import * as React from "react";

/**
 * Das Dokument des ausgelagerten Browserfensters, in dem ein Fensterinhalt
 * gerade steht — `null` heißt: im Hauptfenster.
 */
export const FensterDokumentContext = React.createContext<Document | null>(null);

/** Dokument, in dem diese Komponente gerade dargestellt wird. */
export function useFensterDokument(): Document {
  return React.useContext(FensterDokumentContext) ?? document;
}
